class PaasDefaultJson {
    static baseInfo = {
        appType: "C",
        confId: 0,
        templateId: 1,
        themeColor: "#2C84DD",
        menuSelectedColor: "#2C84DD",
        widthType: 1,
        layersType: 1,
        layersBackgroundType: 1,
        layersLayoutType: 1,
        isMenuTop: 0,
        menuTextColor: "#000000",
        menuColor: "#ffffff",
        backgroundImg: ""
    }
}

export {
    PaasDefaultJson
}


// WEBPACK FOOTER //
// ./src/models/paas-default-json.js